import { Skeleton, TableCell, TableRow } from '@mui/material';

type TableSkeletonRowsProps = {
  rows?: number;
  columns: number;
};

export const TableSkeletonRows = ({ rows = 6, columns }: TableSkeletonRowsProps) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <TableRow key={rowIndex}>
        {Array.from({ length: columns }).map((__, columnIndex) => (
          <TableCell key={columnIndex}>
            <Skeleton height={20} width={columnIndex === 0 ? '70%' : '45%'} />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);
